export default __webpack_public_path__ + "static/ico-openmind-85d50d50d364d1f9bcadf1d4f3bd564e.svg";